import React, { useEffect, useState } from "react";

import LayoutWrapper from "../../../common/LayoutWrapper";
import EmergencyFolder from "../../../components/documents/guardianship/EmergencyFolder";
import Signature from "../../../components/documents/guardianship/Signature";
import GetStarted from "../../../components/documents/guardianship/GetStarted";
import Guardian from "../../../components/documents/guardianship/Guardian";

import { useSelector, useDispatch } from "react-redux";
import { customTab, nextTab, preTab } from "../../../redux/slices/TabSlices";
import { getAssetsOnBoardingList } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { connect } from "react-redux";
import { resetCard } from "../../../redux/slices/CardSlices";
import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";
import { getSBText } from "../../../utils/suggestionBoxUtilities";
import { guardianshipSteps } from "../../../constants/constants";

import "../../../components/yourAssets/BOA/BOA.scss";
import CloseSteps from "../../../common/Swipers/GuardianshipSteps";
import DocSwiper from "../../../common/Swipers/DocsSwiper";

import Overview from "../../../components/documents/guardianship/Overveiw";
import {
  getGuardianOridinance,
  postGuardianOridinance,
} from "../../../services/documentServices";
import {
  getDateFromDateStamp,
  getTimeFromDateStamp,
  getUserIdFromLocalStorage,
  overAllStatus,
  changeUpdateFormat,
} from "../../../utils/Utilities";
import {
  LinkButton,
  PrimaryButton,
  SecondaryButton,
} from "../../../common/Buttons";
import { useTranslation } from "react-i18next";
import { updateStatusQuoAuditTrails } from "../../../services/auditTrails";
import ModifiedByToaster from "../../../common/ModifiedByToaster";
import Wishes from "../../../components/documents/guardianship/Wishes";

const GuardianshipPage = ({
  currentTab,
  nextTab,
  preTab,
  customTab,
  resetCard,
  updates,
}) => {
  const { t, i18n } = useTranslation();
  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const [steps, setSteps] = useState(guardianshipSteps);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [data, setData] = useState(null);
  const handleResetCard = () => {
    resetCard();
  };
  const handleNext = () => {
    handleResetCard();
    nextTab();
  };
  const handleBack = () => {
    handleResetCard();
    preTab();
  };
  const handleCustomTab = (val) => {
    customTab(val);
  };
  const handleUpdatesTrails = async () => {
    const result = await updateStatusQuoAuditTrails(
      updates.map((item) => item.auditTrailId),
      currentConsultantId
    );
  };
  useEffect(() => {
    handleUpdatesTrails();
  }, []);

  const tabMaping = {
    1: (
      <GetStarted
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    2: (
      <Guardian
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
        buttonDisabled={buttonDisabled}
      />
    ),
    3: (
      <Wishes
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
        buttonDisabled={buttonDisabled}
      />
    ),
    4: (
      <EmergencyFolder
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
        buttonDisabled={buttonDisabled}
      />
    ),
    5: (
      <Signature
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
    6: (
      <Overview
        next={handleNext}
        pre={handleBack}
        setButtonDisabled={setButtonDisabled}
      />
    ),
  };
  const dispatch = useDispatch();
  const tabStatuses = useSelector(
    (state) => state.assetsOnBoarding.assetsSuggestionBoxText
  );

  async function fetchData() {
    const arr = [];
    const result = await getGuardianOridinance(uID);
    if (result?.success && result?.payLoad) {
      if (result.payLoad && Object.keys(tabMaping).length === currentTab) {
        setData(result.payLoad);
      }
      const {
        guardianDetermineDetail,
        primaryGuardian,
        secondaryGuardian,
        guardianByNoMean,
        guardianEmergencyStepStatus,
        guardianEmergencies,
      } = result?.payLoad;

      const array = [
        guardianDetermineDetail?.stepStatus,
        primaryGuardian?.stepStatus === 2 &&
        secondaryGuardian?.stepStatus === 2 &&
        guardianByNoMean?.stepStatus === 2
          ? 2
          : 1,
        guardianEmergencyStepStatus || 0,
        guardianEmergencies[0].text ? 2 : 0,
        2,
        2,
      ];

      steps.forEach((elem, index) => {
        if (index !== steps.length - 1) {
          arr.push({ ...elem, stepStatus: array[index] });
        }
        if (index === steps.length - 1) {
          const res = overAllStatus(array);
          arr.push({ ...elem, stepStatus: res ? 2 : 1 });
        }
      });

      setSteps(arr);
    }
  }
  useEffect(() => {
    fetchData();
  }, [currentTab]);

  useEffect(() => {
    dispatch(getAssetsOnBoardingList());
  }, []);

  const renderTab = () => {
    return (
      <>
        {tabMaping[currentTab]}
        {updates.length > 0 && (
          <ModifiedByToaster
            title={`${t("modified-by")} ${updates[0]?.username}` || ""}
            subTitle={` ${changeUpdateFormat(
              updates[0]?.updatedTime,
              i18n.language
            )}`}
          />
        )}
      </>
    );
  };
  return (
    <>
      <LayoutWrapper
        minHeight="calc(100vh - 100px) !important"
        borderShadow={true}
      >
        <DocSwiper
          tab={currentTab}
          back={handleBack}
          custom={handleCustomTab}
          list={steps}
          data={data}
          showTooltip={false}
          handleSubmitStatus={
            Object.keys(tabMaping).length === currentTab
              ? postGuardianOridinance
              : null
          }
        />

        {renderTab()}
        {currentTab !== 2 && currentTab !== 4 && (
          <>
            {currentTab < 5 ? (
              <div
                style={{
                  minWidth: "310px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <SecondaryButton
                  title={t("save-and-continue")}
                  bgColor="#E8D7E5"
                  borderRadius="14px"
                  width="180px"
                  marginLeft="20px"
                  border="none"
                  hoverBgColor="color.magentaLight1"
                  textTransform="initial"
                  padding="0rem"
                  height="2.7rem"
                  form="form_submit"
                  type="submit"
                  disabled={buttonDisabled}
                />

                <LinkButton
                  title={t("skip-for-now")}
                  bgColor="color.transparent"
                  borderRadius="14px"
                  fontSize="0.8rem"
                  width="150px"
                  marginLeft="10px"
                  padding="0"
                  border="none"
                  click={handleNext}
                  textTransform="initial"
                />
              </div>
            ) : (
              <div
                className="button-container-2"
                style={{
                  minWidth: "310px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <PrimaryButton
                  title={t("save")}
                  bgColor="#E8D7E5"
                  color="#444561"
                  padding="10px 60px"
                  textTransform="initial"
                  borderRadius={"18px"}
                  boxShadow={0}
                  form="form_submit"
                />
              </div>
            )}
          </>
        )}
      </LayoutWrapper>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentTab: state.currentTab.currentTab,
    updates: state.statusQuoDocuments.updates.guardianOrdinance,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextTab: () => dispatch(nextTab()),
    preTab: () => dispatch(preTab()),
    customTab: (num) => dispatch(customTab(num)),
    resetCard: () => dispatch(resetCard()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GuardianshipPage);
